import { atoms } from 'views/atoms/atoms-module';
import Handlebars from 'handlebars/runtime';
import _ from 'lodash';

const AtomLoader = {
  atoms: atoms,
  configWhitelist: [
    'cid',
    'atom',
    'classes',
    'txt',
    'beforeContent',
    'afterContent',
    'required',
    'disabled',
    'blocksRegion',
    'iconBefore',
    'iconAfter',
    'contentInjection',
  ],
  loadAtomRegions: function (el) {
    let r = [];
    const atomElements = el.querySelectorAll('[data-atom]');
    [...atomElements].forEach(element => {
      const config = element.dataset || {};
      r = [
        ...r,
        {
          get: () => Object.assign(config, { cid: element.id }),
          clean: () => {
            this.cleanDataAtom(element, config);
          },
        },
      ];
    });
    return r;
  },
  cleanDataAtom(el) {
    const dataAttrs = ['data-aria-label', 'data-content', 'data-close'];
    for (const dataAttr of dataAttrs) {
      if (el.hasAttribute(dataAttr)) {
        el.removeAttribute(dataAttr);
      }
    }
  },
  setAtomConfig(c, el) {
    const config = {};
    Object.keys(c)
      .filter(key => this.configWhitelist.indexOf(key) !== -1)
      .forEach(key => {
        config[key] = c[key];
      });
    if (config.contentInjection === 'true') {
      this.setcontentInjection(config, el);
    }
    return config;
  },
  setAtomAttributes: function (a) {
    let att = '';
    Object.keys(a)
      .filter(key => this.configWhitelist.indexOf(key) === -1)
      .forEach(k => {
        att += `${_.kebabCase(k)}="${a[k]}" `;
      });
    return new Handlebars.SafeString(att);
  },
  setcontentInjection(config, el) {
    const injectionElement = el.querySelector(`#${config.cid}`);
    config.injectedContent = injectionElement.innerHTML.toString();
    const nodes = injectionElement.childNodes;
    for (let n = nodes.length - 1; n > -1; n--) {
      nodes[n].parentElement.removeChild(nodes[n]);
    }
  },
};

export default AtomLoader;
